import React, { useState } from "react";
import privacyChoicesIcon from '../assets/privacy_choices_icon.png'

const Footer = ( props ) => {
  return (
		<footer>
			<div className="">
				<div className="py-1 text-center small">
					<div className="text-center py-1">
						<a href={`${props.redirectBaseUrl}/results`} className="text-dark">Browse Jobs </a> 
						|    
						{(new Date("2023-2-1") >= new Date()) && (new Date() >= new Date("2022-12-18")) ? <a className="text-dark" onClick={() => props.setShowTC(true)}> Terms of Use - UPDATED</a> : <a className="text-dark" onClick={() => props.setShowTC(true)}> Terms of Use</a>}
						|  
						{(new Date("2023-2-1") >= new Date()) && (new Date() >= new Date("2022-12-18")) ? <a className="text-dark" onClick={() => props.setShowPP(true)}> Privacy Policy - UPDATED</a> : <a className="text-dark" onClick={() => props.setShowPP(true)}> Privacy Policy</a>}
						|
						<div style={{display: "inline-block"}}>
							<a className="text-dark cookie-settings" onClick={props.openCmpDrawer}>
								<img src={privacyChoicesIcon} className="privacy-choices-icon" />
								<span className="your-privacy-choices">Your Privacy Choices</span>
							</a>
						</div>
						| 
						<a className="text-dark" onClick={() => props.setShowUnsub(true)}> Unsubscribe </a> 
						| 
						<a className="text-dark" onClick={() => props.setShowDMCA(true)}> DMCA Notice </a> 
						| 
						<a href="https://hire.jobcase.com/purchase/post-now" className="text-dark-red" target="_blank" rel="noopener noreferrer">
							<b> Post a Job</b>
						</a>
					</div>
					<div className="text-center py-1">
						<a className="text-dark" href="https://www.upward.careers/?privacy-policy#section-10">California privacy notice </a> 
					</div>
					<div className="text-center py-1">
						<a href="/" className="text-decoration-none">
							<span>powered by &nbsp; &nbsp;</span>
							<div>
								<img alt="Upward" src="https://www.upward.careers/images/upwardlogo.png" width="70" />
							</div>
						</a>
					</div>
				</div>
			</div>
		</footer>
  )
}

export default Footer;